export const en = {
    "k_f580681d": "You do not have permission to access this project",
    "k_7f5a357e": "You do not have edit rights for this project",
    "k_72f7d125": "Failed to initialize AI project"
};
